
import Vue from "vue";
import {
  NewTenantUsersApiFunc,
  NewWebsitesApiFunc,
  setAccessToken,
} from "@/api";
import { TenantUser, Website } from "@/models";

import TheTemplate from "../TheNoSidebarTemplate.vue";
import BaseCloseButton from "@/components/BaseCloseButton.vue";
import TenantUserEditor from "./components/TenantUserEditor.vue";

export type DataType = {
  tenantUser?: TenantUser;
  websites?: Array<Website>;
};

export default Vue.extend({
  name: "TenantUserDetailScreen",

  components: {
    TheTemplate,
    BaseCloseButton,
    TenantUserEditor,
  },

  data(): DataType {
    return {
      tenantUser: undefined,
      websites: [],
    };
  },

  computed: {},

  mounted() {
    this.fetchWebsites();
    this.getTenantUser();
  },

  methods: {
    async fetchWebsites(): Promise<void> {
      const companyId = this.$auth.companyId;
      if (!companyId) {
        this.$router.replace({ name: "login" });
        return;
      }
      const filterString: string = JSON.stringify({});
      setAccessToken(this.$auth.accessToken);
      const { data, err } = await NewWebsitesApiFunc().listWebsites(
        companyId,
        filterString
      );

      if (err != null) {
        this.$handleApiError(err, this.fetchWebsites);
        return;
      }

      this.websites = data.list;
    },

    async getTenantUser(): Promise<void> {
      const companyId = this.$auth.companyId;
      if (!companyId) {
        this.$router.replace({ name: "login" });
        return;
      }
      const tenantUserId = this.$router.currentRoute.params.tenantUserId;
      setAccessToken(this.$auth.accessToken);
      const { data, err } = await NewTenantUsersApiFunc().getTenantUser(
        companyId,
        tenantUserId
      );

      if (err != null) {
        this.$handleApiError(err, this.getTenantUser);
        return;
      }

      this.tenantUser = data;
    },

    async updateTenantUser(tenantUser: TenantUser): Promise<void> {
      const companyId = this.$auth.companyId;
      if (!companyId) {
        this.$router.replace({ name: "login" });
        return;
      }
      this.$setLoading(true);

      const tenantUserId = this.$router.currentRoute.params.tenantUserId;
      setAccessToken(this.$auth.accessToken);
      const { err } = await NewTenantUsersApiFunc().updateTenantUser(
        companyId,
        tenantUserId,
        tenantUser
      );

      if (err != null) {
        this.$handleApiError(err, () => {
          this.updateTenantUser(tenantUser);
        });
        this.$setLoading(false);
        return;
      }
      this.$setLoading(false);
      this.$setChecked(true);
      this.$afterSuccessRequest(() => {
        this.$router.push({
          name: "company-tenant-users",
          params: {
            updated: "true",
          },
        });
      }, 2);
    },

    afterLeave(): void {
      this.$setChecked(false);
    },
  },
});
